// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const getDefaultFonTSize = (props) => {
  const { input, spc, theme } = props;
  let fontSize;
  if (input && input.value) {
    if (spc) {
      fontSize = theme.fonts.fontSize.body.bodytext.copy3;
    } else {
      fontSize = theme.fonts.fontSize.body.small.primary;
    }
  } else if (spc) {
    fontSize = theme.fonts.fontSize.textbox_input;
  } else {
    fontSize = theme.fonts.fontSize.textbox;
  }
  return fontSize;
};

const styleBottomSpacing = '26px';
const selectStyles = css`
  ${(props) =>
    !props.spc
      ? `position: relative;
        display: block;
        height: ${props.customHeight || '73px'};`
      : ''}

  .select__input {
    appearance: none;
    ${(props) =>
      props.spc
        ? `background: url(${getIconPath('down_arrow_icon', props)}) no-repeat right  ${
            props.theme.spacing.ELEM_SPACING.XS
          }
          bottom 21px  #fff;
          border :1px solid ${props.theme.colors.FOOTER.DIVIDER};
          border-radius: 6px;
          padding: 16px;
          height: 54px;`
        : `background: url(${getIconPath('down_arrow_icon', props)}) no-repeat right ${
            props.downArrowRight || '0px'
          } bottom ${props.downArrowBottom || props.theme.spacing.ELEM_SPACING.SM};
          border-bottom:1px solid ${props.theme.colors.FOOTER.DIVIDER};
          border-radius: 0;
          border-width: 0px 0px 1px;
          padding: ${styleBottomSpacing} 0 6px;`}

    ${({ meta, spc, theme }) =>
      meta && meta.touched && meta.error
        ? ` ${spc ? 'border' : 'border-bottom'}: 1px solid ${theme.colors.TEXTBOX.ERROR_BORDER};`
        : ''};

    color: ${(props) => {
      const selectPlaceHolderText =
        !props.input.value && props.spc
          ? props.theme.colors.TEXT.DARKERGRAY
          : props.theme.colors.TEXTBOX.COLOR;
      return props.disabled && props.spc
        ? props.theme.colorPalette.gray[600]
        : selectPlaceHolderText;
    }};
    margin: 0;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    outline: 0;
    width: 100%;

    ${({ disabled, theme }) =>
      disabled
        ? `
      background-color: ${theme.fieldBackgroundDisabledColor};
      border-color: ${theme.fieldBorderDisabledColor};
    `
        : ''};
    ${(props) =>
      props.input &&
      props.input.value &&
      props.spc &&
      `
      border-color: ${props.theme.colorPalette.blue[800]};
    `}
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
  }

  .select__label {
    font-size: ${(props) => getDefaultFonTSize(props)}px;
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    ${(props) =>
      props.spc
        ? `position: relative;
          bottom: 74px;
          left: 10px;
          background: ${props.theme.colorPalette.white};
           width: 34px;
           padding: 2px 6px;
           color: ${
             !((props.meta?.touched && props.meta?.error) || props.showExplicitError)
               ? props.theme.colorPalette.blue[800]
               : props.theme.colorPalette.red[500]
           };`
        : `padding: 0;
          position: absolute;
          top: 0;`}
  }

  .SelectBox__error {
    display: flex;
    flex-direction: row;
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }

  .quantity-oos {
    color: ${(props) => props.theme.colors.TEXT.GRAY};
  }

  .warning-icon {
    background: transparent url('${(props) => getIconPath('circle-alert-fill', props)}') no-repeat 0
      0;
    background-size: contain;
    border: none;
    height: 14px;
    width: 16px;
    margin-right: 7px;
    flex-shrink: 0;
  }

  .dropdown {
    position: relative;
    margin: 0 auto;
    height: 50px;
    width: 100%;
    border: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    background: ${(props) => props.theme.colorPalette.white};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    ${(props) =>
      props.meta && props.meta.touched && props.meta.error
        ? `border: 1px solid ${props.theme.colors.TEXTBOX.ERROR_BORDER};`
        : ''};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  }

  .dropdown__text {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    cursor: pointer;
    height: auto;
  }

  .dropdown__text--placeholder {
    color: ${(props) => props.theme.colorPalette.gray[800]};
  }

  .dropdown__item {
    cursor: pointer;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    &:hover {
      background: ${(props) => props.theme.colors.BUTTON.WHITE.HOVER};
    }
  }

  .dropdown__text:after {
    content: '';
    border: 1px solid;
    border-width: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXXS} 0;
    float: right;
    margin-top: 1px;
    padding: 5px;
    transform: rotate(45deg);
  }

  .dropdown.active .dropdown__text:after {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    transform: rotate(-135deg);
  }

  .dropdown__items {
    position: relative;
    opacity: 0;
    max-height: 0px;
  }

  .dropdown.active {
    border: 1px solid ${(props) => props.theme.colorPalette.blue[800]};
    border-bottom: 0;
    ul {
      position: absolute;
      z-index: 1;
      background: ${(props) => props.theme.colorPalette.white};
      width: 100%;
      border: 1px solid ${(props) => props.theme.colorPalette.blue[800]};
      border-top: 0;
      border-radius: 0px 0px ${(props) => props.theme.spacing.ELEM_SPACING.XS_6}
        ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
      left: -1px;
      max-height: 100px;
      overflow-y: scroll;
    }
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6}
      ${(props) => props.theme.spacing.ELEM_SPACING.XS_6} 0px 0px;
    .dropdown__items {
      border-top: 1px solid;
      height: auto;
      max-height: ${(props) => props.theme.spacing.LAYOUT_SPACING.XXXL};
      opacity: 1;
    }
  }

  .divider {
    border-bottom: 1px solid ${(props) => props.theme.colorPalette.blue[800]};
    margin: 0px ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }

  .placeholderText {
    position: absolute;
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
    top: -${(props) => props.theme.spacing.ELEM_SPACING.SM};
    left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    background: ${(props) => props.theme.colorPalette.white};
    color: ${(props) => props.theme.colorPalette.blue[800]};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export default selectStyles;
